"use strict";

const webChatConfig = require("./webChatConfig");
const $ = require("jquery");
const axios = require('axios');
const WEB_SOCKET_SERVICE_URL = '/webchat/webSocketServiceUrl';
const STORE_WEB_CHAT_HISTORY_URL = '/webchat/storeWebChatHistory';
const WEB_CHAT_AVAILABILITY_URL = '/api/v1/availability';
const STORE_WEB_CHAT_SURVEY_URL = '/webchat/storeWebChatSurvey';
const IS_AUTHENTICATED_URL = '/webchat/isAuthenticated';
const VERIFY_ACCESS_TOKEN_URL = '/webchat/verifyAccessToken';

/**
 * Store flag in session to indicate that web chat has already been presented to user in case they
 * change pages and all agents are maxed out, web chat should still be presented to these users.
 */
const _storePortalSession = (webChatContent) => {
  const jsonData = JSON.stringify(webChatContent);
  axios
    .post(STORE_WEB_CHAT_HISTORY_URL, jsonData, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .catch((error) => {
      // handle error
      console.log('Error received calling /storeWebChatHistory', error.responseText, error.statusText);
    });
};

const _storeWebChatSurvey = (webChatSurveyData) => {
  return axios
    .post(STORE_WEB_CHAT_SURVEY_URL, webChatSurveyData, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .catch((error) => {
      // handle error
      console.log('Error received calling /storeWebChatSurvey', error.responseText, error.statusText);
    });
};

const _storeWebChat = () => {
  // If Web Chat is active, then store its contents in app server session when leaving page so it can be retrieved
  // on next page.
  if (webChatConfig.chatActive()) {
    console.log("Saving chat in session");
    try {
      storeActiveWebChatInSession();
    } catch (err) {
      // Forward user to error page if there is a problem storing web chat in session.
      console.log("Exception caught trying to save web chat in session", err);
    }
  }
};

/**
 * Make call to APP Server to store an active Web Chat messages in session. Also store the URL Repository
 * links that are used to call Live Chat server as these will be needed if page is opened while an active
 * chat is still available.
 */
const storeActiveWebChatInSession = () => {
  console.log("Making call to App Server to store web chat in session");

  let jsonMessages = [];

  // Get agent introduction message if one exists and store in session also.
  let introductionObj = $("#agentIntroduction");

  if (
    $(introductionObj).find("#agentIntroductionAgentName").text().length > 0
  ) {
    let jsonMessageIntro = {};
    jsonMessageIntro["message"] = $(introductionObj).html();
    jsonMessages.push(jsonMessageIntro);
  }

  let message = null;
  // Get all messages from Web Chat Client
  $(".messageDiv").each((i, obj) => {
    message = $(obj).html();
    // Add message to Json Array Object
    let jsonMessage = {};
    jsonMessage["message"] = message;
    jsonMessages.push(jsonMessage);
  });

  // Only attempt to store Messages in session if chat is active. Also save URL Repository values and chat active flag.
  if (webChatConfig.chatActive()) {
    let chatPresentedToUser = false;
    if (webChatConfig.isAuthenticated()) {
      chatPresentedToUser = true;
    }

    let webChatContent = {
      messages: jsonMessages,
      userName: webChatConfig.userName(),
      agentName: webChatConfig.agentName(),
      webChatHistoryStored: true,
      chatActive: true,
      nbrConnectedAgents: webChatConfig.nbrConnectedAgents(),
      chatPresentedToUser: chatPresentedToUser,
      channelNameToUse: webChatConfig.channelName(),
      isAuthenticated: webChatConfig.isAuthenticated(),
	    webChatSurveyId: webChatConfig.chatSurveyId(),
      webChatId: webChatConfig.chatId(),
      webChatWindowMinimised: webChatConfig.webChatWindowMinimised(),
      unreadMessagesCount: webChatConfig.unreadMessagesCount(),
    };
    _storePortalSession(webChatContent);
  }

  console.log("End Call to APP Server to store web chat in session");
};


const _getCurrentWebChatInSession = () => {

  console.log("Making call to App Server to check session");
  let REVRIEVE_WEB_CHAT_HISTORY_URL = '/webchat/retrieveWebChatHistory';
  let authenticatedPageFlag;
  const pageId = webChatConfig.pageId();
  let aemPage = webChatConfig.aemPage();

  if (aemPage === 'Y') {
      authenticatedPageFlag = 'N';
  } else if (pageId === 'health' || pageId === 'travel' || pageId === 'dental') {
    // public pages
    authenticatedPageFlag = 'N';
  } else if (pageId === 'myvhi-login' || pageId === 'myvhi-registration') {
    // myvhi public pages
    authenticatedPageFlag = 'N';
  } else if (pageId === 'selfservice' || pageId === 'myvhi-mydetails') {
    // myvhi private pages
    authenticatedPageFlag = 'Y';
  } else if ( window.parent.location.href.indexOf("myvhi") > -1) {
      authenticatedPageFlag = 'Y';
  } else {
      authenticatedPageFlag = 'N';
  }
  
  return axios(REVRIEVE_WEB_CHAT_HISTORY_URL+'?authenticatedPage='+authenticatedPageFlag)
  .then(response => response.data)
  .catch(error => {
    console.log('Error received calling /retrieveWebChatHistory', error);
  });
};

const _getAvailabilityApiURL = (channelName, queues) => {
  let url;
  if (channelName) {
    if (webChatConfig.isAuthenticated()) {
      if (webChatConfig.pageId() !== 'selfservice') {
        url = WEB_CHAT_AVAILABILITY_URL + '?launchIdentifier=MYVHI&queues=MYVHI_CHAT_QUEUE';
      } else {
        url = queues ? WEB_CHAT_AVAILABILITY_URL + '?launchIdentifier=' + channelName + '&queues=' + queues
            : WEB_CHAT_AVAILABILITY_URL + '?launchIdentifier=' + channelName + '&queues=' + channelName + "_CHAT_QUEUE";
      }
    } else {
      url = queues ? WEB_CHAT_AVAILABILITY_URL + '?launchIdentifier=' + channelName + '&queues=' + queues
          : WEB_CHAT_AVAILABILITY_URL + '?launchIdentifier=' + channelName + '&queues=' + channelName + "_CHAT_QUEUE";
    }
  } else {
    console.log('Error setting up /api/v1/availability call as channelName is not defined.');
  }
  return url;
};

const _getCurrentWebChatAvailability = (channelName, queues) => {
  console.log("Making call to App Server to check availability");
  let url = _getAvailabilityApiURL(channelName, queues);
  return axios(url)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    console.log('Error received calling /api/v1/availability', error);
  });
};

const _getWebSocketServiceUrl = () => {
  console.log("Making call to App Server to get websocket URL");
  return axios(WEB_SOCKET_SERVICE_URL, {
    headers: {
      'content-type': 'text', 
    },
  })
  .then(response => response.data)
  .catch(error => {
    console.log('Error received calling /webSocketServiceUrl', error);
  });
};

const _isAuthenticated = () => {
  console.log("Making call to check if we have a valid authenticated session.");
  return axios(IS_AUTHENTICATED_URL)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    console.log('Error received calling /isAuthenticated', error);
  });
};

const _verifyTokenCookieDetails = () => {
  console.log("Making call to App Server to verify access token");
  return axios(VERIFY_ACCESS_TOKEN_URL)
      .then(response => {
        if(response === null) {
          webChatConfig.setIsAuthenticated(false);
          return false;
        } else {
          return response.data;
        }
      })
      .catch(error => {
        console.log('Error received calling /verifyAccessToken', error);
      });
};

const _getOktaUserInfo = (oktaUserInfoApiUrl, token) => {
  console.log("Making call to Okta User Info API");
  return axios(oktaUserInfoApiUrl, {
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  })
  .then(response => {
    console.log('Okta userinfo API', response.data);
    return response.data;
  })
  .catch(error => {
    console.log('Error received calling Okta userinfo API', error);
  });
};


module.exports = {
  storePortalSession: _storePortalSession,
  storeWebChat: _storeWebChat,
  getCurrentWebChatInSession: _getCurrentWebChatInSession,
  getWebSocketServiceUrl: _getWebSocketServiceUrl,
  getCurrentWebChatAvailability: _getCurrentWebChatAvailability,
  storeWebChatSurvey: _storeWebChatSurvey,
  isAuthenticated: _isAuthenticated,
  verifyAccessTokenCookieDetails: _verifyTokenCookieDetails,
  getOktaUserInfo: _getOktaUserInfo
};